import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { Link } from "react-router-dom";
import logoImg from "../../../assets/brand/pmp_medical_logo_white.svg";

/**
 * Dark multi-column footer — mirrors AWS footer with #232f3e background,
 * logo top-left, link columns, and slim copyright bar at the bottom.
 */

const footerColumns = [
  {
    title: "Products",
    links: [
      { label: "Browse Catalog", to: "/catalog" },
      { label: "Cleaning & Sterilization", to: "/catalog?category=Cleaning%20%26%20Sterilization" },
      { label: "Footwear", to: "/catalog?category=Footwear" },
      { label: "Automated External Defibrillator", to: "/catalog?category=AED" },
      { label: "Personal Protective Equipment", to: "/catalog?category=PPE" },
    ],
  },
  // Company + Account merged into one column to free a slot for the contact block.
  {
    title: "Company",
    links: [
      { label: "About PMP", to: "/about" },
      { label: "Contact Us", to: "/contacts" },
      { label: "Request a Quote", to: "/contacts" },
      { label: "Sign In", to: "/login" },
      { label: "My Profile", to: "/profile" },
    ],
  },
];

// Office contact details, surfaced in the footer's "Get in Touch" column.
const contactInfo = {
  address: "825 Lawson St. City of Industry, CA 91748",
  phone: "760-757-4455",
  hours: "9am - 5pm PST, Mon - Fri",
};

export default function Footer({ site }) {
  const year = String(new Date().getFullYear());
  const lineLeft =
    site?.footer?.lineLeft?.replaceAll("{year}", year) ??
    `© ${year} PMP. All rights reserved.`;
  const tagline =
    site?.footer?.lineRight ??
    "Wholesale medical supplies, equipment, PPE, and diagnostics. Product availability varies by region and account type.";

  return (
    <footer className="pmp-footer mt-auto" id="contact">
      <div className="pmp-footer-main">
        <Container>
          <Row className="g-4">
            {/* Brand + tagline column */}
            <Col xs={12} md={4} lg={3}>
              <img
                src={logoImg}
                alt="PMP Medical"
                className="pmp-footer-logo"
              />
              <p className="pmp-footer-tagline">{tagline}</p>
            </Col>

            {/* Link columns */}
            {footerColumns.map((col) => (
              <Col key={col.title} xs={6} md={4} lg={3}>
                <div className="pmp-footer-nav-title">{col.title}</div>
                <ul className="list-unstyled mb-0">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      <Link to={link.to} className="pmp-footer-nav-link">
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </Col>
            ))}

            {/* Contact column */}
            <Col xs={12} md={4} lg={3}>
              <div className="pmp-footer-nav-title">Get in Touch</div>
              <address className="pmp-footer-contact mb-0">
                <div className="pmp-footer-contact-item">
                  <i className="bi bi-geo-alt-fill" aria-hidden="true" />
                  <span>{contactInfo.address}</span>
                </div>
                <a
                  href={`tel:${contactInfo.phone.replace(/[^0-9+]/g, "")}`}
                  className="pmp-footer-contact-item"
                >
                  <i className="bi bi-telephone-fill" aria-hidden="true" />
                  <span>{contactInfo.phone}</span>
                </a>
                <div className="pmp-footer-contact-item">
                  <i className="bi bi-clock-fill" aria-hidden="true" />
                  <span>{contactInfo.hours}</span>
                </div>
              </address>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="pmp-footer-bottom">
        <Container>
          <p className="pmp-footer-copy">{lineLeft}</p>
        </Container>
      </div>
    </footer>
  );
}
